import api from "../lib/axios";

/**
 * Fetch all inquiries for a specific exhibitor.
 * @param {string|number} exhibitorId
 */
export const getInquiries = async (exhibitorId, params = {}) => {
  return api.get(`/inquiries/${exhibitorId}`, {
    params,
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};

/**
 * Submit a new inquiry to an exhibitor.
 * @param {object} data
 */
export const submitInquiry = async (data) => {
  return api.post(`/inquiries`, data, {
    headers: {
      "ngrok-skip-browser-warning": "true",
    },
  });
};
